import { render, staticRenderFns } from "./DonateTop.vue?vue&type=template&id=636d5b35&scoped=true&"
import script from "./DonateTop.vue?vue&type=script&lang=js&"
export * from "./DonateTop.vue?vue&type=script&lang=js&"
import style0 from "./DonateTop.vue?vue&type=style&index=0&id=636d5b35&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636d5b35",
  null
  
)

export default component.exports